<script lang="ts">
    import Input from "../../components/formComponents/Input.svelte"
    import { apiBaseURL } from "../../../config"
    import { getDBEntries } from "../../../api"

    export let field: TaskStepField<"checkbox">,
        fullPath: string,
        value: any[] = []

    if (!Array.isArray(value)) value = []

    type Options = {
        value: string | number
        label: string
    }[]
    let options: Options = []
    let optionsLoaded = false

    const endpointCall = async (options: EndpointOptions) => {
        try {
            const response = await getDBEntries(options.endpoint, {
                ...options.params.filter,
            })
            return response.map((item) => ({
                value: item[options.mapping["id"]] || "",
                label: item[options.mapping["name"]] || "",
            }))
        } catch (e) {
            console.error(e)
            return []
        }
    }

    if (Array.isArray(field?.options)) {
        options = field.options
        optionsLoaded = true
    } else if (typeof field?.options === "object") {
        endpointCall({ ...field.options, endpoint: `${apiBaseURL}${field.options.endpoint}` })
            .then((optionsRes) => {
                options = optionsRes
                optionsLoaded = true
            })
            .catch(console.error)
    }

    let booleanValues: boolean[] = []
    let customInputValues: string[] = [""]

    $: if (optionsLoaded) {
        if (!value) value = []
        booleanValues = options.map((option) => value.includes(option.value))

        const validValues = value.filter((val) => options.some((option) => option.value === val))
        customInputValues = value.filter((val) => !options.some((option) => option.value === val))

        if (!field.multipleOtherOptions && customInputValues.length > 1) {
            customInputValues = [customInputValues[0]]
        } else if (field.multipleOtherOptions && !customInputValues.includes("")) {
            customInputValues.push("")
        }

        if (JSON.stringify([...validValues, ...customInputValues.filter((val) => val)]) !== JSON.stringify(value)) {
            value = [...validValues, ...customInputValues.filter((val) => val)]
        }

        booleanValues = options.map((option) => value.includes(option.value))
    }

    function handleCustomInputChange(index: number, event: Event) {
        const target = event.target as HTMLInputElement
        customInputValues[index] = target.value
        customInputValues = customInputValues.filter((val) => val)

        if (field.multipleOtherOptions && !customInputValues.includes("")) {
            customInputValues.push("")
        }

        value = [
            ...value.filter((val) => options.some((option) => option.value === val)),
            ...customInputValues.filter((val) => val),
        ]
    }
</script>

<div class="checkboxes flex-direction-{field.flexDirection}">
    {#each options as option, i}
        <Input
            type="checkbox"
            id="{fullPath}-{option.value}"
            onChange="{() => {
                booleanValues[i] = !booleanValues[i]
                if (booleanValues[i]) value = [...value, option.value]
                else value = value.filter((val) => val !== option.value)
            }}"
            placeholder="{option.label}"
            bind:value="{booleanValues[i]}"
        />
    {/each}
    {#if field.otherOption}
        {#if field.multipleOtherOptions}
            {#each customInputValues as customInputValue, i}
                <Input
                    type="checkboxInput"
                    id="{fullPath}-customInput-{i}"
                    onChange="{(event) => handleCustomInputChange(i, event)}"
                    placeholder="Sonstige"
                    value="{customInputValue}"
                />
            {/each}
        {:else}
            <Input
                type="checkboxInput"
                id="{fullPath}-customInput"
                onChange="{(event) => handleCustomInputChange(0, event)}"
                placeholder="Sonstige"
                value="{customInputValues[0]}"
            />
        {/if}
    {/if}
</div>

<style lang="less">
    @import "../../../../assets/variables.less";
    :global.checkboxes {
        display: flex;
        width: 100%;
        gap: 0.6rem;
        flex-wrap: wrap;
        max-width: 100%;
        .checkbox {
            max-width: 100%;
        }
        &.flex-direction-column {
            flex-direction: column;
            overflow: hidden;
        }
        & > * {
            flex-grow: 1;
            width: 0px;
            min-width: min(100%, 400px);
        }
        @media @mobile {
            flex-direction: row;
            flex-wrap: wrap;
            & > * {
                min-width: 100px;
                width: unset !important;
            }
        }
    }
</style>
